import {
  BottomSheetModalProvider,
  useBottomSheetModal
} from "@gorhom/bottom-sheet";
import useAuthStore from "@repo/core/stores/auth";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { ReactNode, useEffect, useRef } from "react";
import { StyleSheet } from "react-native";

function DismissBottomSheetsOnLogout() {
  const { dismissAll } = useBottomSheetModal();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const wasAuthenticated = useRef(isAuthenticated);

  useEffect(() => {
    if (wasAuthenticated.current && !isAuthenticated) {
      dismissAll();
    }

    wasAuthenticated.current = isAuthenticated;
  }, [dismissAll, isAuthenticated]);

  return null;
}

export function BottomSheetProvider({ children }: { children: ReactNode }) {
  return (
    <GestureHandlerRootView style={styles.container}>
      <BottomSheetModalProvider>
        <DismissBottomSheetsOnLogout />
        {children}
      </BottomSheetModalProvider>
    </GestureHandlerRootView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1
  }
});
